import { useTheme } from 'styled-components';
import {
  BodyLoader,
  BuyCryptoChooseAssetsWrapper,
  AssetIcon,
  AssetName,
  AssetCode,
  CircleIcon,
  Price,
  Change,
  ArrowIcon,
} from './styles';

type BuyCryptoChooseAssetLoaderProps = {
  shouldShowCircleIcon?: boolean;
};

export const BuyCryptoChooseAssetLoader: React.FC<
  BuyCryptoChooseAssetLoaderProps
> = ({ shouldShowCircleIcon = true }) => {
  const { colors } = useTheme();

  return (
    <BuyCryptoChooseAssetsWrapper>
      {[...Array(5)].map((item, i) => {
        return (
          <BodyLoader
            key={i}
            backgroundColor={colors.surface.interactiveDefault}
            foregroundColor={colors.surface.pressed}
          >
            {shouldShowCircleIcon && <CircleIcon />}
            <AssetIcon shouldShowCircleIcon={shouldShowCircleIcon} />
            <AssetName shouldShowCircleIcon={shouldShowCircleIcon} />
            <AssetCode shouldShowCircleIcon={shouldShowCircleIcon} />
            <Price />
            <Change />
            <ArrowIcon />
          </BodyLoader>
        );
      })}
    </BuyCryptoChooseAssetsWrapper>
  );
};
